import React from 'react';
import { FaCreditCard, FaReceipt } from 'react-icons/fa';
import { MenuSection, SectionHeader, MenuItem, MenuItemIcon, MenuItemText } from '../Styles/AccountMenuStyles';

const MyPayments = ({ onItemClick }) => {
  return (
    <MenuSection>
      <SectionHeader>My Payments</SectionHeader>
      <MenuItem>
        <MenuItemIcon>
          <FaCreditCard className="w-5 h-5 text-kuality-blue" />
        </MenuItemIcon>
        <MenuItemText>Bank & UPI Details</MenuItemText>
      </MenuItem>
      <MenuItem>
        <MenuItemIcon>
          <FaReceipt className="w-5 h-5 text-kuality-blue" />
        </MenuItemIcon>
        <MenuItemText>Payment & Refund</MenuItemText>
      </MenuItem>
    </MenuSection>
  );
};

export default MyPayments;